import React, { Component } from 'react';
import PropTypes from 'prop-types';
import range from 'lodash/range';
import moment from 'moment';
import classNames from 'classnames';
import { Checkbox, Dropdown } from 'semantic-ui-react';
import { Modal, ModalBody } from 'reactstrap';
import PopupCalendar from '../PopupCalendar/PopupCalendar';
import InstantBook from '../InstantBook/InstantBook';
import './WeekSchedule.css';

const options = [
  { text: '0 Hours', value: 'zero_hours', key: 0 },
  { text: 'Part Time', value: 'part_time', key: 1 },
  { text: 'Full Time', value: 'full_time', key: 2 },
];

class WeekSchedule extends Component {
  state = { modal: false };

  constructor(props) {
    super(props);
    this.handleChangeAvailability = this.handleChangeAvailability.bind(this);
    this.getDayStyle = this.getDayStyle.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  handleChangeAvailability(event, { value }) {
    this.props.handleAdvancedHours({ hours: value });
  }

  getDayStyle(day) {
    const { advancedAvailability } = this.props;

    const scheduledDay = advancedAvailability.find(d =>
      moment(d.day).isSame(day),
    );

    if (!scheduledDay) return '';

    if (scheduledDay.hours === 8 && scheduledDay.available)
      return 'full-time-background';

    return scheduledDay.available ? 'day-green' : 'day-red';
  }

  getDropdownValue() {}

  toggle() {
    this.setState(prevState => ({
      modal: !prevState.modal,
    }));
  }

  render() {
    const {
      handleToggleInstantBooking,
      handleToggleAvailability,
      handleAdvancedDay,
      handleAdvancedCheckbox,
      user: {
        instant_book: instantBook,
        available_schedule: availableSchedule,
      },
      instantBookInfo,
      handleUpdateInstantBookInfo,
    } = this.props;
    return (
      <div className="row">
        <div className="col-12 col-lg-9 my-4 d-flex">
          <div className="bg-white shadow-mid p-4 d-flex align-self-stretch">
            <div className="row align-self-stretch">
              <div className="col">
                <p className="t-21 font-weight-bold text-darkgreen">
                  My Schedule: Basic Availability
                </p>
              </div>
              <div className="col d-flex">
                <div className="ml-auto custom-checkbox-key">
                  <div className="legend">Unavailable</div>
                  <Checkbox
                    name="availability"
                    toggle
                    onChange={handleToggleAvailability}
                    defaultChecked={availableSchedule}
                  />
                  <div
                    className={classNames(
                      'legend',
                      availableSchedule && 'text-teal-2',
                    )}
                  >
                    Available
                  </div>
                </div>
              </div>
              <div className="col-12">
                <p className="t-13 my-4">
                  Set your general availability for each day. These are the
                  default values, specific daily <br />
                  availability can be changed individually in the calendar
                  below.
                </p>
              </div>
              <div className="col-12">
                <div className="schedule__week-availability">
                  {this.renderWeekDropdown()}
                </div>
              </div>
              <div className="col-12 text-right align-self-end">
                <a
                  className="t-13 d-block text-dark-teal font-weight-normal"
                  onClick={this.toggle}
                >
                  Advanced Booking Options
                </a>

                <Modal isOpen={this.state.modal} toggle={this.toggle} centered>
                  <ModalBody>
                    <div className="row mb-5">
                      <div className="col-12 text-right">
                        <i
                          onClick={this.toggle}
                          className="icon icon-close text-blue t-20 cursor-pointer"
                        />
                      </div>
                      <div className="col text-center">
                        <h2 className="t-34 text-darkgreen">
                          Advanced Booking
                        </h2>
                        <p className="t-17 text-gray-mate">
                          Allows freelancer to schedule their own time by
                          selecting dates, availability, and part-time or
                          full-time.
                        </p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <PopupCalendar
                          onChange={handleAdvancedDay}
                          getDayStyle={this.getDayStyle}
                        >
                          <Checkbox
                            className="available"
                            label="Available"
                            onChange={handleAdvancedCheckbox}
                          />
                          <Dropdown
                            placeholder="N/A"
                            selection
                            options={range(9).map(i => ({
                              text: i,
                              value: i,
                              key: i,
                            }))}
                            value={this.getDropdownValue()}
                            onChange={this.handleChangeAvailability}
                          />
                        </PopupCalendar>
                      </div>
                    </div>
                  </ModalBody>
                </Modal>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-lg my-4 d-flex">
          <InstantBook
            handleToggleInstantBooking={handleToggleInstantBooking}
            handleUpdateInstantBookInfo={handleUpdateInstantBookInfo}
            instantBook={instantBook}
            instantBookInfo={instantBookInfo}
          />
        </div>
      </div>
    );
  }

  getClassName(index) {
    const { weekAvailability } = this.props;
    const weekday = weekAvailability.find(w => w.day === index);
    return weekday ? weekday.hours : '';
  }
  renderWeekDropdown() {
    const { weekAvailability } = this.props;

    const { handleSelectTime } = this.props;

    const days = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];

    return (
      <div className="row week-gutters justify-content-center schedule__week-availability-inputs">
        {[0, 1, 2, 3, 4, 5, 6].map(i => {
          const weekDay = weekAvailability.find(week => week.day === i);

          return (
            <div key={i} className="col-4 col-md-2 col-lg mb-3">
              <div
                className={`day text-center p-2 t-10 t-md-14 mb-2 day-${i} ${this.getClassName(
                  i,
                )}`}
              >
                {days[i]}
              </div>
              <div className="input-container">
                <Dropdown
                  className="t-13"
                  placeholder="N/A"
                  fluid
                  name={`week-day-${i}`}
                  selection
                  weekday={i}
                  onChange={(event, data) => handleSelectTime(event, data)}
                  options={options}
                  value={weekDay ? weekDay.hours : undefined}
                />
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}

WeekSchedule.propTypes = {
  user: PropTypes.object,
  handleSelectTime: PropTypes.func,
  weekAvailability: PropTypes.array,
  advancedAvailability: PropTypes.array,
  handleToggleAvailability: PropTypes.func,
  handleToggleInstantBooking: PropTypes.func,
  handleAdvancedHours: PropTypes.func,
  handleAdvancedDay: PropTypes.func,
  handleAdvancedCheckbox: PropTypes.func,
  instantBookInfo: PropTypes.array,
  handleUpdateInstantBookInfo: PropTypes.func,
};

export default WeekSchedule;



// WEBPACK FOOTER //
// ./src/components/DashboardFreelancerMain/WeekSchedule/WeekSchedule.js